import React from 'react';
import cx from 'classnames';
import { Me } from '@xingternal/platform-layout-me';
import { LinkItem } from './LinkItem';
import { SettingsDropdownListPropTypes } from './prop-types';
import { createHelpLink } from './utils';
import styles from './SettingsDropdownList.css';
const keyToClassname = (s) => ({
    premiumUpsellPersonal: 'premiumUpsellItem',
    proJobsPersonal: 'proJobsItem',
}[s]);
const SettingsDropdownList = ({ armstrongV1, intl, links, helpLink, closeModal, location: { pathname }, }) => (React.createElement("div", { className: styles.itemList },
    React.createElement(Me, { patternId: "settings-dropdown" }),
    React.createElement("div", { className: styles.linkGroup }, links.map((link) => {
        const baseProps = {
            link,
            intl,
            closeModal,
        };
        const linkProps = link.key === 'helpPersonal' // help is a different kind of link than the data based ones
            ? {
                ...baseProps,
                link: {
                    ...link,
                    target: '_blank',
                    rel: 'noopener noreferrer',
                    href: helpLink || createHelpLink(intl.locale, pathname),
                    onClick: (e) => {
                        e.preventDefault();
                        let newUrl = helpLink || createHelpLink(intl.locale, pathname);
                        if (armstrongV1) {
                            const [url, params] = newUrl.split('?');
                            newUrl = params
                                ? `${url}?${params}&mode=arm`
                                : `${url}?mode=arm`;
                        }
                        window.location.assign(newUrl);
                    },
                },
            }
            : baseProps;
        return (React.createElement(LinkItem, { "data-qa": `SettingsDropdown-list-item-${link.key}`, className: cx({
                [styles[keyToClassname(link.key)]]: Boolean(keyToClassname(link.key)),
            }), key: link.key, ...linkProps }));
    }))));
SettingsDropdownList.propTypes = SettingsDropdownListPropTypes;
export { SettingsDropdownList };
//# sourceMappingURL=SettingsDropdownList.js.map